import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'
import Modal from '../../../UniformComponents/Modal'
import * as SkipLogicPreview from '../../SkipLogic/Preview'

@observer
export default class PageSkipLogicPreview extends Component {
    modalKey = 'pageSkipLogicPreview'

    render() {
        const { store } = this.props
        const { survey, modalConfig } = store
        const { page, kind } = modalConfig

        const locale = R.pathOr('', ['surveyLocale'], survey)
        const defaultLocale = R.pathOr('', ['survey', 'metadata', 'defaultLocale'], store)
        const locales = {
            locale,
            defaultLocale,
        }

        if (!store.modals.get(this.modalKey)) return null

        const title = kind === 'pageToPage' ? 'pageLogic' : 'displayLogic'

        return (
            <Modal
                show={store.modals.get(this.modalKey)}
                onClose={() => store.hideModal(this.modalKey)}
                style={{ width: '1000px' }}
            >
                <div id="page-delete-modal">
                    <div className="uc-modal__header">
                        <h2>{i18n.t(title)}</h2>
                    </div>

                    <br />

                    {(
                        kind === 'pageToPage'
                            ? SkipLogicPreview.pageToPage(survey, page, locales)
                            : SkipLogicPreview.showPage(survey, page, locales)
                    )}
                </div>
            </Modal>
        )
    }
}
